import {
    Component,
    Input,
    AfterViewInit,
    ElementRef,
    OnInit,
    ViewChild,
} from '@angular/core';
import { Feed } from '../../home-page/home-page.data';
import { RouteExecutor } from '../../@core/application-router/route.executor';
import { ApplicationRouterService } from '../../@core/application-router/application-router.service';
import { HomePageService } from '../../home-page/home-page.service';
import { SharedLayoutsService } from '../shared-layouts.service';

@Component({
    selector: 'app-category-tab-section-v2',
    templateUrl: './category-tab-section-v2.component.html',
    styleUrls: ['./category-tab-section-v2.component.scss'],
})
export class CategoryTabSectionV2Component
    extends RouteExecutor
    implements OnInit, AfterViewInit
{
    @Input() item: any;
    @Input() showShimmer = true;
    selectedTab = 0;
    tabData: Feed | undefined;
    isBot = true;
    iosWeb = false;
    visitedTabs: { [key: number]: boolean } = {};
    @ViewChild('swiperSlide') swiperSlide!: ElementRef;
    swiperSlideHeight = '0px';
    @ViewChild('categoryCards') categoryCards!: ElementRef;
    categoryCardsHeight = '0px';

    constructor(
        applicationRouterService: ApplicationRouterService,
        public homepageService: HomePageService,
        protected sharedLayoutsService: SharedLayoutsService,
        private elementRef: ElementRef
    ) {
        super(applicationRouterService);
    }

    ngOnInit(): void {
        if (!!this.item && this.item?.layoutContent?.feed) {
            this.tabData = this.item?.layoutContent?.feed[this.selectedTab];
        }
        this.isBot = this.homepageService.detectBotUser();
        this.iosWeb = /iPad|iPhone|iPod/.test(navigator.userAgent);
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.swiperSlide) {
                const height = this.swiperSlide.nativeElement.offsetHeight;
                this.swiperSlideHeight = `${height}px`;
            }
            if (this.categoryCards) {
                const height = this.categoryCards.nativeElement.offsetHeight;
                this.categoryCardsHeight = `${height}px`;
            }
        }, 0);
    }

    executeFunctionLink(id: string, query: { [p: string]: string | string[] }) {
        switch (query?.action) {
            case 'change-tab':
                this.selectedTab = +query?.index;
                const index = +query?.index;
                this.showShimmer = !this.visitedTabs[index];
                setTimeout(() => {
                    if (this.item?.layoutContent?.feed) {
                        this.tabData = this.item?.layoutContent?.feed[index];
                    }
                    this.visitedTabs[index] = true;
                    this.showShimmer = false;
                    this.resetProductListScroll();
                }, 300);
                break;
        }
    }

    resetProductListScroll() {
        const productListContainer =
            this.elementRef.nativeElement.querySelector(
                '.categorytab-cards-row'
            );
        if (productListContainer) {
            productListContainer.scrollTo({
                left: 0,
                behavior: this.iosWeb ? 'smooth' : 'auto',
            });
        }
    }
}
